{
  "name": "ukata-admin",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host=0.0.0.0 --disable-host-check --configuration development",
    "dev": "ng serve --host=0.0.0.0 --disable-host-check --configuration development",
    "serve": "ng serve --host=0.0.0.0 --disable-host-check --configuration development",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.6",
    "@angular/cdk": "^22.1.6",
    "@angular/common": "^22.1.6",
    "@angular/compiler": "^22.1.6",
    "@angular/core": "^22.1.6",
    "@angular/forms": "^22.1.6",
    "@angular/material": "^22.1.6",
    "@angular/platform-browser": "^22.1.6",
    "@angular/platform-browser-dynamic": "^22.1.6",
    "@angular/router": "^22.1.6",
    "@ctrl/tinycolor": "^4.1.0",
    "@microsoft/fetch-event-source": "^2.0.1",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@types/node": "^20.12.7",
    "@types/showdown": "^2.0.6",
    "keycloak-angular": "^22.0.0",
    "keycloak-js": "^25.0.0",
    "marked": "^18.0.12",
    "marked-katex-extension": "^5.1.12",
    "monaco-editor": "^0.56.0",
    "ngx-markdown": "^22.0.2",
    "ngx-monaco-editor-v2": "^22.0.5",
    "ngx-quill": "^31.0.1",
    "plyr": "^3.7.8",
    "prismjs": "^1.29.0",
    "quill": "^2.0.0",
    "recordrtc": "^5.6.2",
    "rxjs": "~7.5.7",
    "showdown": "^2.1.0",
    "tslib": "^2.6.2",
    "uuid": "^9.0.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.8",
    "@angular/cli": "~22.1.8",
    "@angular/compiler-cli": "^22.1.6",
    "@fullhuman/postcss-purgecss": "^6.0.0",
    "@types/jasmine": "~4.3.6",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.5.0",
    "karma": "~6.4.3",
    "karma-chrome-launcher": "~3.1.1",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "~6.0.3"
  }
}
